import Vue from 'vue'
import App from './App.vue'
import Error from './Error'

// VeeValidate
import {ValidationObserver, ValidationProvider} from 'vee-validate'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
// Rules
require('./rules');

import {ModalPlugin, ProgressPlugin, DropdownPlugin, CollapsePlugin, AlertPlugin} from 'bootstrap-vue'

Vue.use(CollapsePlugin)
Vue.use(ModalPlugin)
Vue.use(ProgressPlugin)
Vue.use(DropdownPlugin)
Vue.use(AlertPlugin)

import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})
Vue.prototype.$toast = Toast

// audio recorder
import AudioRecorder from 'vue-audio-recorder'

Vue.use(AudioRecorder)
import VueCarousel from 'vue-carousel'

Vue.use(VueCarousel)

import router from './routes'
// Axios
import axios from 'axios'

Vue.prototype.$axios = axios

window.host = process.env.VUE_APP_PROXY
const baseUrl = host + '/api/student'

axios.defaults.baseURL = baseUrl
axios.defaults.baseApiUrl = host + '/api'
axios.defaults.withCredentials = true;


// load store after axios init
import store from "./store/store";
import echo from "./echo"
import moment from "moment";

moment.locale('fr')

// helpers
Vue.prototype.$clone = (data) => JSON.parse(JSON.stringify(data))
Vue.prototype.$slugId = (slug) => {
  return parseInt(slug.split('-').reverse()[0])
}

Vue.prototype.$format2Digits = (n) => {
  if (n >= 0 && n < 10) return '0' + n
  return n
}

Vue.filter('date', function (val) {
  return moment(val).format('lll')
})

window.login = function (login = "jbd", password = "secret") {
  axios.get('/sanctum/csrf-cookie', {baseURL: host}).then(response => {
    axios.post('/api/login', {login, password}, {baseURL: host})
      .then(() => window.location = '/')
  });
}

window.logout = function () {
  axios.post('/api/logout', {}, {baseURL: host})
    .finally(() => window.location = store.getters.home_url)
}

function start() {
  axios.get('/home').then(({data}) => {
    store.commit('set_data', data)
    window.vue = new Vue({
      el: '#app',
      render: h => h(App),
      router,
      store
    })
    echo.init()
  })
    .catch((error) => {
      if (error.response.data.redirect) {
        return window.location = error.response.data.redirect
      }
      const msg = error.response.data.message
      if (msg === 'Unauthenticated.' && process.env.NODE_ENV === 'production') {
        return window.location = process.env.VUE_APP_HOME + '/?login=true'
      }
      new Vue({
        el: '#app',
        data: {
          msg: msg
        },
        render: h => h(Error)
      })
    })
}

// import styles
Promise.all([
  import('./assets/sass/app.scss'),
  import('@fortawesome/fontawesome-free/css/all.css')
])
  .then(start)
